import React, { forwardRef, useRef, useImperativeHandle } from "react"
import PropTypes from "prop-types"
import { Table, Col, Row } from "reactstrap"
import downloadBanner from "assets/images/other/bannerDownload.png"
import verified from "assets/images/other/verified.png"
import { InspectionDocumentsParameters } from "../Crud/parameters"
import moment from "moment"
import html2pdf from "html2pdf.js"

const HEADER_HEIGHT = 80
const FOOTER_HEIGHT = 40

const InspectionDocumentDetailsPDF = forwardRef(
  ({ inspectionDetails, inspectionSections }, ref) => {
    const pdfRef = useRef(null)

    useImperativeHandle(ref, () => ({
      downloadPDF: () => {
        const element = pdfRef.current
        if (!element) return
        const opt = {
          margin: [10, 10, 10, 10],
          filename: "inspection-details.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        }
        html2pdf().set(opt).from(element).save()
      },
    }))
    const handleDownloadPDF = () => {
      setHidePdfButtons(true)
      setTimeout(() => {
        const element = pdfRef.current
        if (!element) {
          setHidePdfButtons(false)
          return
        }
        const opt = {
          margin: 0,
          filename: "inspection-details.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 1, useCORS: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        }
        html2pdf()
          .set(opt)
          .from(element)
          .save()
          .then(() => setHidePdfButtons(false))
          .catch(() => setHidePdfButtons(false))
      }, 300) // Slightly increased timeout for React state update
    }

    return (
      <>
        <h1>hello</h1>
        {/* <div ref={pdfRef} style={{ display: "none" }}>    */}
        <div
          ref={pdfRef}
          style={{
            position: "absolute",
            left: "-9999px",
            top: 0,
            width: "210mm", // A4 width
            background: "#fff",
            zIndex: -1,
          }}
        >
          {" "}
          {/* <div ref={pdfRef} > */}
          <style>
            {`
        .html2pdf__page-header, .html2pdf__page-footer {
          width: 100%;
          position: fixed;
          left: 0;
          right: 0;
          background: #fff;
          z-index: 1000;
        }
        .html2pdf__page-header {
          top: 0;
          height: ${HEADER_HEIGHT}px;
          border-bottom: 2px solid #eee;
          padding-bottom: 8px;
        }
        .html2pdf__page-footer {
          bottom: 0;
          height: ${FOOTER_HEIGHT}px;
          border-top: 2px solid #eee;
          padding-top: 8px;
          text-align: center;
          font-size: 0.9em;
          color: #888;
        }
        .pdf-content {
          padding-top: ${HEADER_HEIGHT + 10}px;
          padding-bottom: ${FOOTER_HEIGHT + 10}px;
          background: #fff;
        }
        @media print {
          .html2pdf__page-header, .html2pdf__page-footer {
            position: fixed;
          }
          .pdf-content {
            page-break-after: always;
          }
        }
        `}
          </style>
          {/* Header */}
          <div className="html2pdf__page-header">
            <img
              src={downloadBanner}
              alt="Focus Motors Banner"
              style={{ maxWidth: "100%", height: "60px", objectFit: "contain" }}
            />
          </div>
          {/* Footer (repeats on every page) */}
          <div className="html2pdf__page-footer">
            Focus Motors Inspection Report &copy; {new Date().getFullYear()}
          </div>
          {/* Main Content */}
          <div className="pdf-content">
            {/* Inspection Info */}
            <Row className="mb-3">
              <Col md="3">
                <div>
                  <span className="grey-color fw-light">Inspection Date</span>
                </div>
                <div className="text-black">
                  {inspectionDetails?.inspection_data?.inspected_date
                    ? moment(
                      inspectionDetails.inspection_data.inspected_date
                    ).format("DD/MM/YYYY")
                    : "---"}
                </div>
              </Col>
              <Col md="3">
                <div>
                  <span className="grey-color fw-light">Inspection No.</span>
                </div>
                <div className="text-black">
                  {inspectionDetails?.inspection_data?.inspection_number ||
                    "---"}
                </div>
              </Col>
              <Col md="3">
                <div>
                  <span className="grey-color fw-light">Inspected By</span>
                </div>
                <div className="text-black">
                  {inspectionDetails?.inspection_data?.inspected_by?.name ||
                    "---"}
                </div>
              </Col>
              <Col md="3">
                <div>
                  <span className="grey-color fw-light">Booking No.</span>
                </div>
                <div className="text-black">
                  {inspectionDetails?.booking_id || "---"}
                </div>
              </Col>
            </Row>
            {/* Vehicle & Owner Data */}
            <Row className="mb-4">
              <Col md="8">
                <h6 className="bg-light p-2">VEHICLE DATA</h6>
                <Table borderless size="sm" className="table white-cell">
                  <tbody>
                    <tr>
                      <td>
                        <span className="grey-color">Vehicle Brand :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.brand?.name || "---"}
                      </td>
                      <td>
                        <span className="grey-color">Reg. No. :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.vehicleNumber || "---"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color">Vehicle Model :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.model?.name || "---"}
                      </td>
                      <td>
                        <span className="grey-color">Year :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.makeYear}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color">Vehicle Variant :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.variant?.name || "---"}
                      </td>
                      <td>
                        <span className="grey-color">KM :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.kiloMeter || "---"}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td className="text-end text-black"></td>
                      <td>
                        <span className="grey-color">Fuel :</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.vehicle?.fuelType || "---"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md="4">
                <h6 className="bg-light p-2">OWNER DATA</h6>
                <Table borderless size="sm" className="table white-cell">
                  <tbody>
                    <tr>
                      <td>
                        <span className="grey-color"> Name:</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.owner_details?.customer_name ||
                          "---"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color"> Phone:</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.owner_details?.phone_number ||
                          "---"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color"> State:</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.owner_details?.state?.name || "---"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color"> District:</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.owner_details?.district?.name ||
                          "---"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="grey-color"> Address:</span>
                      </td>
                      <td className="text-end text-black">
                        {inspectionDetails?.owner_details?.address || "---"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            {/* Other Details */}
            <Row>
              <Col md="12">
                <h6 className="bg-light p-2">OTHER DETAILS</h6>
                <Row>
                  <Col md={6}>
                    <div>
                      <span className="grey-color fw-light">Finance </span>
                    </div>
                    <div className="text-black">
                      <span
                        style={{
                          display: "inline-block",
                          background: "#d6f4f9",
                          color: "#006c9c",
                          borderRadius: "10px",
                          marginTop: "5px",
                          padding: "0.25em 1em",
                          fontWeight: 500,
                          fontSize: "1em",
                        }}
                      >
                        {inspectionDetails?.finance === "false" ? "No" : "yes"}
                      </span>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div>
                      <span className="text-black fw-light">
                        Replacement Report{" "}
                      </span>
                    </div>
                    <div className="grey-color-light">
                      {inspectionDetails?.replacement_report || "---"}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div style={{ margin: "16px 0" }}>
              <hr className="flex-grow-1 solid-line" />
            </div>
            {/* Sections */}
            <Row className="pt-3 mb-1">
              {(() => {
                let serial = 1
                return inspectionSections?.map((section, secIdx) => {
                  const params =
                    InspectionDocumentsParameters?.[section.key] || []
                  const metric =
                    inspectionDetails?.check_metrics?.[section.metricIndex]
                      ?.section?.parameters || []
                  if (!params.length) return null
                  return (
                    <React.Fragment key={section.key}>
                      <h5
                        className={`${secIdx === 0 ? "mb-2" : "mt-2 mb-2"
                          } text-black`}
                        style={{ fontWeight: "800" }}
                      >
                        {section.title}
                      </h5>
                      {params.map((param, index) => {
                        const currentSerial = serial++
                        return (
                          <div
                            key={index}
                            style={{
                              minWidth: 480,
                              borderRadius: 6,
                              padding: "8px",
                            }}
                            className="mb-2 d-flex align-items-center"
                          >
                            <div
                              className="d-flex align-items-center px-2"
                              style={{ minWidth: 480 }}
                            >
                              <p className="mb-0 " style={{ color: "#495057" }}>
                                {currentSerial}. &nbsp;
                              </p>
                              <p className="mb-0 " style={{ color: "#495057" }}>
                                {param}
                              </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                              <p
                                className="pe-2 mb-0 text-black"
                                style={{
                                  whiteSpace: "nowrap",
                                  marginTop: "2px",
                                }}
                              >
                                &nbsp; Good
                              </p>
                              <div style={{ marginBottom: "-2px" }}>
                                <input
                                  type="checkbox"
                                  checked={metric?.[index]?.status ?? false}
                                  readOnly
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    accentColor: "#28a745",
                                  }}
                                />
                              </div>
                              <div
                                className="w-100 "
                                style={{ marginLeft: "20px" }}
                              >
                                <div
                                  className="text-black"
                                  style={{
                                    width: "100%",
                                    borderBottom: "1px solid #e0e0e0",
                                    padding: "6px 0 2px 0",
                                    fontSize: "1em",
                                  }}
                                >
                                  {metric?.[index]?.value ?? ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </React.Fragment>
                  )
                })
              })()}
            </Row>

            <div style={{ margin: "16px 0" }}>
              <hr className="flex-grow-1 solid-line" />
            </div>

            <Row>
              <Col md={6}>
                <div>
                  <span className="text-black fw-light">Remarks{" "}</span>
                </div>
                <div className=" grey-color-light ">
                  {inspectionDetails?.remarks || "---"}{" "}
                </div>{" "}
              </Col>
            </Row>


            {/* Footer image */}
            <Row className="align-items-end mb-4 justify-content-end">
              <img
                src={verified}
                alt="verified"
                style={{
                  maxWidth: "120px",
                  height: "120px",
                  objectFit: "contain",
                }}
              />
            </Row>
          </div>
        </div>
      </>
    )
    // }
  }
)

InspectionDocumentDetailsPDF.displayName = "InspectionDocumentDetailsPDF"

InspectionDocumentDetailsPDF.propTypes = {
  inspectionDetails: PropTypes.object.isRequired,
  inspectionSections: PropTypes.array.isRequired,
}

export default InspectionDocumentDetailsPDF
